"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.font5XLarge = exports.font4XLarge = exports.font3XLarge = exports.font2XLarge = exports.fontXLarge = exports.fontLarge = exports.fontMedium = exports.fontSmall = exports.fontXSmall = void 0;
exports.fontXSmall = "10px";
exports.fontSmall = "12px";
exports.fontMedium = "14px";
exports.fontLarge = "16px";
exports.fontXLarge = "18px";
exports.font2XLarge = "20px";
exports.font3XLarge = "24px";
exports.font4XLarge = "32px";
exports.font5XLarge = "48px";